import React from 'react';
import { ShoppingCartIcon, HouseIcon, UtensilsCrossedIcon, ShirtIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const categories = [{
  icon: ShoppingCartIcon,
  title: 'Grocery and market runs',
  body: 'Your weekly or monthly market list, sorted.'
}, {
  icon: HouseIcon,
  title: 'Household items',
  body: 'Cleaning supplies, kitchen basics and everyday needs.'
}, {
  icon: UtensilsCrossedIcon,
  title: 'Food stuff',
  body: 'Rice, beans, oil, spices, yam, fresh produce.'
}, {
  icon: ShirtIcon,
  title: 'Clothing and perfumes',
  body: 'Fabric, ready-to-wear pieces and scents.'
}];
export function WhatIShopFor() {
  return <section id="what-i-shop-for" className="w-full bg-white py-14 sm:py-20" data-id="element-209" data-mp="2ey7vwhv1onkq">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-210" data-mp="2a06c1upsok87">
        <Reveal className="text-center md:text-left" data-id="element-211" data-mp="37g20i4la5yqh">
          <h2 className="font-display text-3xl uppercase tracking-tight text-purple sm:text-4xl" data-id="element-212" data-mp="37hwojrrum6ys">What I Shop For</h2>
          <p className="mt-2 text-ink/60" data-id="element-213" data-mp="32ninb8qi95m7">Anything you would go to the market for, I can pick it up.</p>
        </Reveal>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-214" data-mp="s9d5y091g0g2">
          {categories.map(({
          icon: Icon,
          title,
          body
        }, index) => <Reveal key={title} delay={index * 0.08} className="group rounded-card border border-lavender bg-lavender-light p-6 text-center shadow-soft transition duration-300 hover:-translate-y-1.5 hover:border-purple/30 hover:shadow-lift md:text-left" data-id="element-215" data-mp="dk721yz99m1u" data-mpi={index}>
              <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-purple transition duration-300 group-hover:scale-110 group-hover:-rotate-6 md:mx-0" data-id="element-216" data-mp="8lm9mlq8w6ny">
                <Icon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-217" data-mp="3vptvbi5gtioq" />
              </span>
              <h3 className="mt-4 text-base font-bold text-purple" data-id="element-218" data-mp="1ozvnun0rwf12">{title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-ink/70" data-id="element-219" data-mp="1oxt069n3exzi">{body}</p>
            </Reveal>)}
        </div>
      </div>
    </section>;
}